<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>未激活运单</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="疏港计划号:" prop="planNo">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom.planNo"></el-input>
          </el-form-item>
          <el-form-item label="车队:" prop="fleetId">
            <el-select v-model="searchFrom.fleetId" placeholder="请选择">
              <el-option
                v-for="(item,index) in fleetOptions"
                :key="index"
                :label="item.fleetName"
                :value="item.fleet">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号:" prop="vehicleNo">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom.vehicleNo"></el-input>
          </el-form-item>
          <el-form-item label="船名:" prop="shipName">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom.shipName"></el-input>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode='001P007B001' >查询</el-button>
            <el-button type="primary" @click="chongZhiClick" btnCode='001P007B001' >重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
         <el-table-column prop="overrunFlag"   label="超限标记" align="center" >
            <template slot-scope="scope"><div>
              <span v-if="scope.row.overrunFlag == '0'">无</span>
              <span v-if="scope.row.overrunFlag == '1'">超</span>
            </div></template>
         </el-table-column>
        <el-table-column prop="waybillNo"   label="运单编号" align="center" width="200" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="" label="港口派车时间"  align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.wharfSendTime == '' || scope.row.wharfSendTime == undefined || scope.row.wharfSendTime == null">-</span>
            <span v-else>{{scope.row.wharfSendTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="vehicleNo"    label="车牌号" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="waybillStatus"  label="运单状态"  width="120" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="ext3"  label="未激活原因"  width="200" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="planNo" label="疏港计划号（单号）" align="center" width="170" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="purorderNo"    label="采购订单号" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="purplanNo"  label="采购日计划号" align="center" width="230" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="fleetName" label="车队"  align="center" width="170" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="driverName"    label="司机"  width="100" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="driverMobile" label="电话" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="goodsName"    label="物料名称" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="shipName"  label="船名" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfName" label="港口"  align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfxName" label="码头"  align="center" ></el-table-column>
        <el-table-column prop="areaName"    label="码头场区"  width="100" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="stackPosition" label="码头垛位" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="warehouseName"    label="收货仓库" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="locationName"  label="收货库位" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="sfirstTare" label="港口一检皮重"  align="center" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.sfirstTare == undefined || scope.row.sfirstTare == null || scope.row.sfirstTare == ''">-</span>
            <span v-else>{{scope.row.sfirstTare.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="sgrossWeight"  label="港口二检毛重" align="center" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.sgrossWeight == undefined || scope.row.sgrossWeight == null || scope.row.sgrossWeight == ''">-</span>
            <span v-else>{{scope.row.sgrossWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="ssuttle" label="港口出货净重"  align="center" width="160" >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.ssuttle == undefined || scope.row.ssuttle == null || scope.row.ssuttle == ''">-</span>
            <span v-else>{{scope.row.ssuttle.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="efirstTare" label="进厂一检毛重"  align="center" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.efirstTare == undefined || scope.row.efirstTare == null || scope.row.efirstTare == ''">-</span>
            <span v-else>{{scope.row.efirstTare.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="egrossWeight"    label="出厂二检皮重"  width="150" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="esuttle" label="进厂货物净重" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="grossErrorRate"    label="毛重误差率（‰）" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="netErrorRate"  label="净重误差率（‰）" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="" label="司机上报时间"  align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.sbTime == '' || scope.row.sbTime == undefined || scope.row.sbTime == null">-</span>
            <span v-else>{{scope.row.sbTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="wharfSendUser" label="派车人"  align="center" width="150" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="" label="出港过磅时间"  align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.wharfOutTime == '' || scope.row.wharfOutTime == undefined || scope.row.wharfOutTime == null">-</span>
            <span v-else>{{scope.row.wharfOutTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="" label="进厂过磅时间"  width="180" align="center">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.plantInTime == '' || scope.row.plantInTime == undefined || scope.row.plantInTime == null">-</span>
            <span v-else>{{scope.row.plantInTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="" label="出厂过磅时间" align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.plantOutTime == '' || scope.row.plantOutTime == undefined || scope.row.plantOutTime == null">-</span>
            <span v-else>{{scope.row.plantOutTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="" label="司机完成时间" align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.finishTime == '' || scope.row.finishTime == undefined || scope.row.finishTime == null">-</span>
            <span v-else>{{scope.row.finishTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="" label="撤销时间" align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.wharfCancelTime == '' || scope.row.wharfCancelTime == undefined || scope.row.wharfCancelTime == null">-</span>
            <span v-else>{{scope.row.wharfCancelTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
      </el-table>
      <!-- 分页 10,25,50,100-->
      <div >
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[10,25,50,100]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  validFind, // 列表
  fleetList
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P007B001', '001P007B002', '001P007B003',
        '001P007B004', '001P007B005', '001P007B006',
        '001P007B007', '001P007B008'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10
      },
      tableList: [],
      tabLoading: false,
      fleetOptions: []
    }
  },
  filters: {
    rounding (value) {
      return value.toFixed(3)
    }
  },
  created () {
    this.getSeatchData()
    this.fleetOptionsInit()
    this.btnFlg = getBtn(this.btnIdArr, '/sgWaybill/waybillSearch')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 100) + 'px'
  },
  methods: {
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      validFind(this.searchFrom).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        DonMessage.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData()
    },
    chongZhiClick () {
      this.searchFrom = {
        pageSize: 10,
        pageNo: 1
      }
      this.getSeatchData()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 25px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}
.searchBtnBox{
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.mapBox{
  width: 100%;
  height: 560px;
  position: relative;
}
.map{
  width: 100%;
  height: 100%;
}
</style>
